import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import audioPlaybackHandler from './middleware/audioPlaybackHandler';

// Creates the store to store our data
// Adds all the reducers to the store
// Can configure other options if needed
// See https://redux-toolkit.js.org/api/configureStore
export const store = configureStore({ 
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(audioPlaybackHandler),
});
